module.exports = __webpack_public_path__ + "static/media/html.acd5a2ae.png";